export default "__VITE_ASSET__DOiyzD46__"